/**
 * Side-wide tools to help make things work consistently across the site.
 * @module global/page
 */
 define(
    'page',['jquery', 'jquery-ui', 'global_helper', 'jquery.cookie', 'xdate', 'thirdparty-global'],
    function($) {
        /*
         * window.onerror
         * Set a "global" window.onerror, but we can override on a case-by-case basis.
         */
        /*
        PWD: disable this for a day and just use Muscula. It is averaging almost 1M entries a day
        var old_on_error = null;
        if(typeof(window.onerror) === "function" ) {
            old_on_error = window.onerror;
        }

        window.onerror = function(errorMsg, url, lineNumber) {

            try {
                var to_log = {
                    error_message:  errorMsg,
                    error_file:     url,
                    error_line:     lineNumber
                };

                Vspot.global_helper.client_logger(to_log, "Javascript Error");

                // Open the error dialog with default info
                // Vspot.global_helper.open_error_dialog(to_log);
                //
            // Tell the browser we got this
                // return true;

                if( typeof(old_on_error) === "function" ) {
                    return old_on_error();
                }
            }
            catch (e) {
                // bad idea to let exceptions bubble out of this
            }
        };
         */

        $(document).ready(function(){
            // If we are on a small screen, center the page
            var w_width = $(window).width();
            var d_width = $(document).width();
            if( w_width < d_width ) {
                $(window).scrollLeft( (d_width - w_width) / 2 );
            }

            // Enable any tabs (if jquery UI loaded)
            if( typeof( $(".tabs").tabs ) === "function" ) {
                $(".tabs").tabs({
                    create: function(event, ui) {
                        $(this).show();
                    }
                });
            }

            var fb;
            // make facebook optional, in case the service is blocked or down
            require(['facebook'],
                function(FB) {
                    fb = FB;
                },
                function(error) {
                    // load failed
                }
            );

            // Facebook icon
            $("#facebook_open, .fb-share").click(function() {
                if (fb) {
                    fb.ui({
                        method: "share",
                        href: $("meta[property='og:url']").attr("content")
                    });
                }
            });

            /*
             * Mailto links:
             * Chrome opens these in gmail. We want that to happen in a new window.
             * We'll check for a target. If there is one, we'll assume it's good.
             * If not, we'll make it "_blank".
             */
            $("body")
                .on("click", "a[href^='mailto']", function(event){
                    var target = $(this).attr("target");
                    if(typeof(target) === "undefined") {
                        $(this).attr("target", "_blank");
                    }
                });

            // pinterest counter/pin-it
            var pinterest_helper = {
                over_pin_it: false,
                show_pin_it: function() {
                    $("#pinterest_pin_it").slideDown();
                },
                hide_pin_it: function() {
                    if(pinterest_helper.over_pin_it === false) {
                        $("#pinterest_pin_it").slideUp();
                    }
                }
            };

            $("#pinterest_pin_it").hover(
                function() {
                    pinterest_helper.over_pin_it = true;
                },
                function() {
                    pinterest_helper.over_pin_it = false;
                    pinterest_helper.hide_pin_it();
                }
            );

            // Check for messages to include
            if (Vspot.headerMessage) {
                $("#bad-browser-message").html(Vspot.headerMessage);
            } else if( Vspot.oldBrowser ) {
                $("#bad-browser-message").html("<span class=\"notice\">ALERT:</span> You appear to be browsing this site with an old browser. This browser is out of date<br>and unsupported. For a safer, more reliable browsing experience please <a href=\"http://www.updateyourbrowser.net/en/\">upgrade as soon as possible</a>.");
            }

            // See if we can display the message
            if( ($.cookie("bad_browser_message_closed") === null || typeof($.cookie("bad_browser_message_closed")) === 'undefined' ) && $("#bad-browser-message").length > 0 && $("#bad-browser-message").html().length > 0 ) {
                // No cookie set, and message is there, so we can show the message
                $("#bad-browser").show();
            }

            // Handle clicking the close link
            $("#bad-browser-close").click(function() {
                // Set the cookie
                $.cookie("bad_browser_message_closed", true);

                // Close the message
                $("#bad-browser").hide();
            });

            // Global events
            $("#page_top, #content_container").not(".popup") // In this case, not document, but only pop-up links not already in a pop-up
                .on("click", ".pop-up", function(event){
                    Vspot.global_helper.open_new_window($(this).data("href") || $(this).attr("href") || false, // url
                                                        $(this), // element
                                                        ( $(this).attr("debug") !== undefined && $(this).attr("debug") === "true" ) || false, // debug
                                                        $(this).attr("window_name"), // windowName
                                                        $(this).attr("window_specs")); // windowSpecs
                    event.preventDefault();
                    // If the click is launching a pop-up window, we don't want it doing other things... probably. Might need a config option on this.
                    event.stopPropagation();
                });


            // Make links open in the parent window, and then close the current window - only happens in pop-ups
            $("#pop_up_wrapper a.parent").click(function(event) {
                event.preventDefault();
                var url = $(this).attr("href") || false;
                if(url) {
                    window.opener.window.top.document.location = url;
                    window.close(); // This doesn't work anymore... need to rethink
                }
            });
            
            require(["thirdparty-global"]);
        });
    }
);
